<div *ngIf="showLanguage">
  <select class="form-control" #SelectedLang (change)="changeLanguage(SelectedLang.value)">
    <option *ngFor="let language of languageList"
            [value]="language.code"
            [selected]="language.code==lang">
      {{language.label}}
    </option>
  </select>
</div>
